import styled, { css } from "styled-components";
export const cssResetStyles = css `
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  font-weight: normal;
  letter-spacing: normal;
  margin: 0;
  padding: 0;
  text-transform: none;
`;
export const cssDisplay600 = css `
  ${cssResetStyles};
  font-size: 40px;
  line-height: 48px;
  color: ${(p) => p.theme.systemColors.black};
`;
export const cssDisplay400 = css `
  ${cssResetStyles};
  font-size: 32px;
  line-height: 40px;
  color: ${(p) => p.theme.systemColors.black};
`;
export const cssDisplay200 = css `
  ${cssResetStyles};
  font-size: 28px;
  line-height: 36px;
  color: ${(p) => p.theme.systemColors.black};
`;
export const cssDisplay100 = css `
  ${cssResetStyles};
  font-size: 24px;
  line-height: 32px;
  color: ${(p) => p.theme.systemColors.black};
`;
export const cssDisplay50 = css `
  ${cssResetStyles};
  font-size: 20px;
  line-height: 26px;
  color: ${(p) => p.theme.systemColors.black};
`;
export const cssBody600 = css `
  ${cssResetStyles};
  font-size: 18px;
  line-height: 26px;
  color: ${(p) => p.theme.systemColors.black};
`;
export const cssBody400 = css `
  ${cssResetStyles};
  font-size: 16px;
  line-height: 24px;
  color: ${(p) => p.theme.systemColors.grey600};
`;
export const cssBody200 = css `
  ${cssResetStyles};
  font-size: 14px;
  line-height: 18px;
  color: ${(p) => p.theme.systemColors.grey600};
`;
export const cssBody100 = css `
  ${cssResetStyles};
  font-size: 12px;
  line-height: 16px;
  color: ${(p) => p.theme.systemColors.grey600};
`;
export const cssDisplay600Bold = css `
  ${cssResetStyles};
  ${cssDisplay600};
  font-weight: 800;
`;
export const cssDisplay400Bold = css `
  ${cssResetStyles};
  ${cssDisplay400};
  color: ${(p) => p.theme.systemColors.black};
  font-weight: 800;
`;
export const cssDisplay200Bold = css `
  ${cssResetStyles};
  ${cssDisplay200};
  color: ${(p) => p.theme.systemColors.black};
  font-weight: 800;
`;
export const cssDisplay100Bold = css `
  ${cssResetStyles};
  ${cssDisplay100};
  color: ${(p) => p.theme.systemColors.black};
  font-weight: 800;
`;
export const cssDisplay50Bold = css `
  ${cssResetStyles};
  ${cssDisplay50};
  font-weight: 800;
`;
export const cssBody600Bold = css `
  ${cssResetStyles};
  ${cssBody600};
  font-weight: 700;
`;
export const cssBody400Bold = css `
  ${cssResetStyles};
  ${cssBody400};
  font-weight: 700;
`;
export const cssBody200Bold = css `
  ${cssResetStyles};
  ${cssBody200};
  font-weight: 700;
`;
export const cssBody100Bold = css `
  ${cssResetStyles};
  ${cssBody100};
  font-weight: 700;
`;
// Components
export const Display600 = styled.h1 `
  ${cssDisplay600}
`;
export const Display400 = styled.h2 `
  ${cssDisplay400}
`;
export const Display200 = styled.h3 `
  ${cssDisplay200}
`;
export const Display100 = styled.h4 `
  ${cssDisplay100}
`;
export const Display50 = styled.h5 `
  ${cssDisplay50}
`;
export const Body600 = styled.p `
  ${cssBody600}
`;
export const Body400 = styled.p `
  ${cssBody400}
`;
export const Body200 = styled.p `
  ${cssBody200}
`;
export const Body100 = styled.p `
  ${cssBody100}
`;
